import React, { useEffect } from "react";
import RegisterHeader from "./Common/Header";
import { Button, Container, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useRegister } from "../../context/RegisterContext";
import Footer from "../Footer";

const RegisterService = () => {
  const navigate = useNavigate();
  const { canProceed } = useRegister();

  useEffect(() => {
    if (!canProceed()) {
      navigate("/parceiros");
      return;
    }
  }, []);

  return (
    <div className="Register">
      <RegisterHeader />

      <Container maxWidth="sm" className="MainContainer">
        <Typography variant="h1" className="Title">
          Valor do serviço
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            fontSize: "14px",
            mt: "50px",
            color: "#000",
            marginBottom: "8px",
          }}
        >
          Valor por lavagem completa
        </Typography>
        <Typography
          variant="h5"
          sx={{ fontWeight: 400, fontSize: "14px", color: "#000" }}
        >
          O nosso valor de repasse por lavagem interna e externa é de R$ 35,00,
          ao clicar em continuar você aceita os termos e condições.
        </Typography>

        <Grid container mt={"50px"} spacing={2}>
          <Grid item xs={12} sm={6}>
            <Button
              variant="contained"
              className="BackButton"
              fullWidth
              onClick={() => navigate("/register/carwash")}
            >
              Voltar
            </Button>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button
              variant="contained"
              className="SendButton"
              fullWidth
              type="submit"
              onClick={() => navigate("/register/signup")}
            >
              Continuar
            </Button>
          </Grid>
        </Grid>
      </Container>

      <Footer />
    </div>
  );
};

export default RegisterService;
